import React from 'react'
import "./Make_difference.css"
import { useNavigate } from 'react-router-dom'

export default function Make_difference() {
    const navigate = useNavigate();
    return (
        <section className='make-difference-section'>
            <div className='container'>
                <div className='content'>
                    <div className='para'>
                        Make A Difference With Experts
                    </div>
                    <div className='btn-warn'>
                        <button className='btn btn-warning' onClick={() => navigate("/contact-us")}> Join Now</button>
                    </div>
                </div>

            </div>
            <div className='img-overlay'></div>

        </section>
    )
}
